import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/**
 * "Кастомная" card-back slot in ArenaProfilePage's card-backs grid opens
 * this — a player describes the design they want, submits it, and gets an
 * in-modal success screen (mirrors RecalculateStatsModal's confirm/success
 * view-swap pattern) rather than just a toast, since the user explicitly
 * expects a persistent "your idea is under review" screen. The
 * already-pending guard itself lives in ArenaProfilePage (checked before
 * this modal is even opened, via arenaHasPendingCustomCardBackRequest) —
 * the 422 handling here is just defense in depth against a race (e.g. two
 * tabs open at once).
 */
export default class CustomCardBackRequestModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "message", '');
    _defineProperty(this, "loading", false);
    _defineProperty(this, "submitted", false);
  }
  className() {
    return 'ArenaCustomCardBackRequestModal Modal--medium';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-palette"
    }), " ", app.translator.trans('forumaker-arena.forum.profile.card_backs.custom.modal_title'));
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, this.submitted ? this.successView() : this.formView());
  }
  formView() {
    return m("div", {
      className: "ArenaCustomCardBackRequestModal-form"
    }, m("div", {
      className: "Form-group"
    }, m("textarea", {
      className: "FormControl",
      rows: 5
      // Mirrors RequestCustomCardBackController::MESSAGE_MAX_LENGTH —
      // just a courtesy so normal use never hits the server's 422 for
      // this; the server enforces the real limit regardless.
      ,
      maxLength: 2000,
      value: this.message,
      oninput: e => {
        this.message = e.target.value;
      },
      placeholder: app.translator.trans('forumaker-arena.forum.profile.card_backs.custom.textarea_placeholder')
    })), m("div", {
      className: "ArenaCustomCardBackRequestModal-actions"
    }, m("span", {
      className: "ArenaCustomCardBackRequestModal-price"
    }, app.translator.trans('forumaker-arena.forum.profile.card_backs.custom.price_note')), m(Button, {
      className: "Button Button--primary",
      loading: this.loading,
      disabled: !this.message.trim(),
      onclick: () => this.submit()
    }, app.translator.trans('forumaker-arena.forum.profile.card_backs.custom.submit_btn'))));
  }
  successView() {
    return m("div", {
      className: "ArenaCustomCardBackRequestModal-success"
    }, m("div", {
      className: "ArenaCustomCardBackRequestModal-successIcon"
    }, m("i", {
      className: "fas fa-check-circle"
    })), m("p", null, app.translator.trans('forumaker-arena.forum.profile.card_backs.custom.success')), m(Button, {
      className: "Button Button--primary",
      onclick: () => this.hide()
    }, app.translator.trans('forumaker-arena.forum.profile.card_backs.custom.close_btn')));
  }
  async submit() {
    const message = this.message.trim();
    if (!message) return;
    this.loading = true;
    m.redraw();
    try {
      await app.request({
        method: 'POST',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/custom-card-back/request"),
        body: {
          message
        }
      });

      // Optimistically flips the flag on the shared User model instance so
      // the "Кастомная" slot immediately reflects the pending state without
      // needing a full reload — see ArenaProfilePage's onclick guard.
      this.attrs.user.pushData({
        attributes: {
          arenaHasPendingCustomCardBackRequest: true
        }
      });
      this.submitted = true;
    } catch (e) {
      if ((e == null ? void 0 : e.status) === 422) {
        this.hide();
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('forumaker-arena.forum.profile.card_backs.custom.already_pending'));
      } else {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('forumaker-arena.forum.profile.card_backs.custom.error'));
      }
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/CustomCardBackRequestModal', CustomCardBackRequestModal);